import React from 'react'
import PrivacyPolicy from '../components/PrivacyPolicy'

export default function PrivacyPolicyPage() {
  return (
    <div className="legal-page">
      <PrivacyPolicy isModal={false} />
    </div>
  )
}